import React from 'react';
import { Button } from './ui/Button';
import { ArrowRight } from 'lucide-react';
export function Hero() {
  const scrollToPricing = () => {
    const pricingSection = document.getElementById('pricing');
    if (pricingSection) {
      pricingSection.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }
  };
  return <section className="relative w-full overflow-hidden bg-[#1a3a52] text-[#f5f1e8]" data-id="element-99">
      {/* Background decoration */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden opacity-10 pointer-events-none" data-id="element-100">
        <div className="absolute -top-24 -right-24 w-96 h-96 rounded-full bg-[#d4af37] blur-3xl" data-id="element-101"></div>
        <div className="absolute top-1/2 -left-24 w-64 h-64 rounded-full bg-[#d4af37] blur-3xl" data-id="element-102"></div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 lg:py-32 relative z-10" data-id="element-103">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-104">
          {/* Text Content */}
          <div className="space-y-8 text-center lg:text-left animate-fade-in-up" data-id="element-105">
            <div className="inline-block px-4 py-1 rounded-full border border-[#d4af37]/30 bg-[#d4af37]/10 text-[#d4af37] text-sm font-medium tracking-wide mb-4" data-id="element-106">
              GUÍA DE 30 DÍAS
            </div>

            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold leading-tight font-serif" data-id="element-107">
              Desbloquea <br data-id="element-108" />
              <span className="text-[#d4af37]" data-id="element-109">Tu Potencial</span>
            </h1>

            <p className="text-xl md:text-2xl text-gray-300 font-light leading-relaxed max-w-2xl mx-auto lg:mx-0" data-id="element-110">
              Supera la ansiedad diaria y recupera tu paz interior con un método
              práctico de micro-pausas y afirmaciones.
            </p>

            <div className="flex flex-col sm:flex-row gap-4 justify-center lg:justify-start pt-4" data-id="element-111">
              <Button size="lg" className="font-semibold text-lg group" onClick={scrollToPricing} data-id="element-112">
                Comenzar Ahora
                <ArrowRight className="ml-2 h-5 w-5 transition-transform group-hover:translate-x-1" data-id="element-113" />
              </Button>
              <Button variant="outline" size="lg" className="border-[#d4af37] text-[#d4af37] hover:bg-[#d4af37] hover:text-[#1a3a52]" onClick={scrollToPricing} data-id="element-114">
                Saber más
              </Button>
            </div>

            <p className="text-sm text-gray-400 pt-2" data-id="element-115">
              Empieza hoy mismo tu camino hacia la calma.
            </p>
          </div>

          {/* Image Content */}
          <div className="relative flex justify-center lg:justify-end animate-fade-in" data-id="element-116">
            <div className="relative w-full max-w-md lg:max-w-lg aspect-[4/5] rounded-2xl overflow-hidden shadow-2xl border border-[#d4af37]/20" data-id="element-117">
              <img src="https://cdn.magicpatterns.com/uploads/b2sMGp8TUuCKg1sdPphmcH/heylloyd-image-1770165599240.png" alt="Desbloquea tu potencial - Llave dorada con alas" className="w-full h-full object-cover transform hover:scale-105 transition-transform duration-700" data-id="element-118" />

              {/* Floating Badge */}
              <div className="absolute bottom-6 left-6 right-6 bg-[#1a3a52]/90 backdrop-blur-sm p-4 rounded-xl border border-[#d4af37]/30 text-center" data-id="element-119">
                <p className="text-[#d4af37] font-serif text-lg italic" data-id="element-120">
                  "Cuando en mí la angustia iba en aumento, tu consuelo llenaba
                  mi alma de alegría"
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}